import { Middleware } from '@reduxjs/toolkit';

// Keys for localStorage
const SOLUTIONS_FILTERS_KEY = 'hcltech_solutions_filters';
const SOLUTIONS_VIEW_MODE_KEY = 'hcltech_solutions_view_mode';
const SOLUTIONS_SEARCH_KEY = 'hcltech_solutions_search';
const CONTENT_SEARCH_KEY = 'hcltech_content_search';
const AGENTS_FILTERS_KEY = 'hcltech_agents_filters';
const AGENTS_SEARCH_KEY = 'hcltech_agents_search';

// Middleware to save state to localStorage
export const localStorageMiddleware: Middleware = (store) => (next) => (action: any) => {
  const result = next(action);
  const state = store.getState();

  try {
    // Save solutions filters
    if (action.type?.startsWith('solutions/')) {
      localStorage.setItem(
        SOLUTIONS_FILTERS_KEY,
        JSON.stringify(state.solutions.activeFilters)
      );
      localStorage.setItem(
        SOLUTIONS_VIEW_MODE_KEY,
        state.solutions.viewMode
      );
      localStorage.setItem(
        SOLUTIONS_SEARCH_KEY,
        state.solutions.searchQuery
      );
    }

    // Save content search
    if (action.type?.startsWith('content/')) {
      localStorage.setItem(
        CONTENT_SEARCH_KEY,
        state.content.searchQuery
      );
    }

    // Save agents filters and search
    if (action.type?.startsWith('agents/')) {
      localStorage.setItem(
        AGENTS_FILTERS_KEY,
        JSON.stringify(state.agents.activeFilters)
      );
      localStorage.setItem(
        AGENTS_SEARCH_KEY,
        state.agents.searchQuery
      );
    }
  } catch (error) {
    console.error('Error saving state to localStorage:', error);
  }

  return result;
};
